import React, { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import ConfigData from "../../master/components/ConfigData";
import { Checkbox, Button, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, } from "@material-ui/core";
import { EmptyCollection, ExportMenu, FilterComponent, Pagination, ImportMenu, DeletePopUp, PageLoader, STableLoader, RevisionHistory } from "../../../shared_elements";
import { globalDeleteService, globalExportService, globalGetService, globalPostService, globalPutService } from "../../../../globalServices";
import { checkApiStatus,checkPermission } from "../../../utils_v2";
import AircraftModelsList from "../components/AircraftModelsList";
import AddEditAircraftModels from "../components/AddEditAircraftModels";
import { trackActivity } from "../../../../utils/mixpanel";
import { Link, withRouter } from 'react-router';
import AddIcon from '@material-ui/icons/Add';
import LinkingPopup from "../../../shared_elements/LinkingPopup";
import NoAccess from "../components/NoAccess";
import { usePageTitleOffset } from '../../../elements/CollapsibleSideNav';

const AircraftModelsObj = {
    name: null,
    remarks: null,
    ac_types: null
}

const AircraftModelsHeader = ({isModel, handleSelectAll, isSelectAllChecked, createSortHandler, sortInfo, deleted }) => {
    return (
        <TableHead>
            <TableRow>
                {!deleted ? <TableCell >{checkPermission('config_data', 'aircraft_models', 'D') &&<Checkbox checked={isSelectAllChecked} onChange={handleSelectAll} color="primary" size="small" />}Action(s)</TableCell> : null}
                <TableCell >
                    {!isModel ? <TableSortLabel
                        active={sortInfo.sort === 'name' ? true : false}
                        direction={sortInfo.sort === 'name' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('name')}
                    >
                        Name
                    </TableSortLabel> : "Name"}
                </TableCell>
                <TableCell >
                    Linked A/C Type
                </TableCell>
                <TableCell >
                    {!isModel ? <TableSortLabel
                        active={sortInfo.sort === 'created_by' ? true : false}
                        direction={sortInfo.sort === 'created_by' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('created_by')}
                    >
                        Created By
                    </TableSortLabel> : "Created By"}
                </TableCell>
                <TableCell >
                    {!isModel ? <TableSortLabel
                        active={sortInfo.sort === 'updated_by' ? true : false}
                        direction={sortInfo.sort === 'updated_by' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('updated_by')}
                    >
                        Last Updated By
                    </TableSortLabel> : "Last Updated By" }
                </TableCell>
                <TableCell >
                    { !isModel ? <TableSortLabel
                        active={sortInfo.sort === 'remarks' ? true : false}
                        direction={sortInfo.sort === 'remarks' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('remarks')}
                    >
                        Remarks
                    </TableSortLabel> : "Remarks" }
                </TableCell>
            </TableRow>
        </TableHead >
    )
}
const AircraftModels = ({ params, isModel, deleted }) => {
    const navTitleOffset = usePageTitleOffset('configDataNavCollapsed');
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState({});
    const [pageSelections, setPageSelections] = useState({});
    const [currentPage, setCurrentPage] = useState({});
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [bulkDelete, setBulkDelete] = useState({ modal: false, data: null })
    const [bulkRevert, setBulkRevert] = useState({ modal: false, data: null })
    const [bulkUnlink, setBulkUnLink] = useState({ modal: false, data: null })
    const [deleteAircraftModels, setDeleteAircraftModels] = useState({ modal: false, data: null });
    const [revertAircraftModels, setRevertAircraftModels] = useState({ modal: false, data: null });
    const [unLinkAircarftModels, setUnLinkAircarftModels] = useState({ modal: false, data: null });
    const [addEditAircraftModels, setAddEditAircraftModels] = useState({ modal: false, data: null, type: '' });
    const [aircraftModelsInfo, setAircraftModelsInfo] = useState({ list: [], pagination: {} });
    const [linkingAircraftModel, setLinkingAircraftModel] = useState({ modal: false, data: null })
    const [circularLoader, setCircularloader] = useState(false)
    const [aircraftTypeInfo, setAircraftTypeInfo] = useState([]);

    useEffect(() => {
        getAirCraftModels({ per_page: 50 }, !isModel ? "skeletonLoader" : "pageLoader");
        trackActivity('Console Management', { page_title: !isModel ? 'Config Data : Aircraft Models' : 'Config Data : Aircraft Types View page', event_type: !isModel ? 'Page Visited' : 'Aircraft Models Tab Clicked' })
        getAircraftType()
    }, [])


    const getAirCraftModels = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);

        const url = !isModel ? `config-data/aircraft-model/` : `config-data/aircraft-type/?linked_aircraft_types_name=aircraft_model&id=${params?.id}&action=link`;

        globalGetService(url, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setAircraftModelsInfo(response.data.data)
                    if(query){
                        delete query.page
                        delete query.per_page
                        delete query.sort
                        delete query.sort_by
                        setFilter(query)
                    }
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }

    const toggleBulkOps = (item, checked, currentPage) => {
        setPageSelections(prevSelections => {
            const updatedSelections = { ...prevSelections };
            if (checked) {
                updatedSelections[currentPage] = updatedSelections[currentPage] || [];
                updatedSelections[currentPage].push(item.id);
            } else {
                updatedSelections[currentPage] = updatedSelections[currentPage].filter(id => id !== item.id);
            }
            return updatedSelections;
        });
    };

    const onDelete = () => {
        setLoading(true);
        const ids = !deleteAircraftModels.data ? Object.values(pageSelections).flat().filter(id => {
            const item = aircraftModelsInfo.list.find(item => item.id === id);
            return item && !item.deleted_at;
        }) : deleteAircraftModels.data.id

        globalDeleteService(`config-data/aircraft-model/bulk-delete/`, { ids })
            .then(response => {
                if (checkApiStatus(response)) {
                    setDeleteAircraftModels({ modal: false, data: null });
                    getAirCraftModels({ ...filter, page: aircraftModelsInfo?.pagination?.page, per_page: aircraftModelsInfo?.pagination?.per_page }, 'pageLoader');
                    setCurrentPage({});
                    setLoading(false);
                    setPageSelections({});
                    setBulkDelete({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Aircraft Models',
                        event_type: `Item Deleted`,
                        event_desc: 'Aircraft Models Deleted Successfully',
                        success_msg: response?.data?.message,
                        deleted_id: ids
                    });
                } else {
                    setDeleteAircraftModels({ modal: false, data: null });
                    setLoading(false);
                    setPageSelections({});
                    setBulkDelete({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Aircraft Models',
                        event_type: `Item Deleted`,
                        event_desc: 'Aircraft Models Deletion Failed',
                        error_msg: response?.data?.message,
                        item_id: ids
                    });
                }
            });
    };

    const onRevert = () => {
        setLoading(true);
        const ids = !revertAircraftModels.data ? Object.values(pageSelections).flat().filter(id => {
            const item = aircraftModelsInfo.list.find(item => item.id === id);
            return item && item.deleted_at;
        }) : revertAircraftModels.data;

        globalPutService(`config-data/aircraft-model/restore/`, { ids })
            .then(response => {
                if (checkApiStatus(response)) {
                    setRevertAircraftModels({ modal: false, data: null });
                    getAirCraftModels({ ...filter, page: aircraftModelsInfo?.pagination?.page, per_page: aircraftModelsInfo?.pagination?.per_page }, 'pageLoader');
                    setCurrentPage({});
                    setLoading(false);
                    setPageSelections({});
                    setBulkRevert({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Aircraft Models',
                        event_type: `Item Reverted`,
                        event_desc: 'Aircraft Models Reverted Successfully',
                        success_msg: response?.data?.message,
                        reverted_id: ids
                    });
                } else {
                    setRevertAircraftModels({ modal: false, data: null });
                    setLoading(false);
                    setPageSelections({});
                    setBulkRevert({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Aircraft Models',
                        event_type: `Item Reverted`,
                        event_desc: 'Aircraft Models Reversion Failed',
                        error_msg: response?.data?.message,
                        item_id: ids
                    });
                }
            });
    };

    const linkUnlink = (type, ids) => {
        const idss = !unLinkAircarftModels.data ? Object.values(pageSelections).flat().filter(id => id) : [unLinkAircarftModels?.data?.id]
        let payload;
        if (type === 'link') {
            payload = {
                aircraft_type_id: params.id || null,
                linked_aircraft_types: "aircraft_model" || null,
                ids: ids || [],
            };
        } else {
            payload = {
                aircraft_type_id: params.id || null,
                linked_aircraft_types: "aircraft_model" || null,
                ids: idss || [],
                action: 'unlink'
            };
        }

        const apiUrl = `config-data/aircraft-type/`;
        setCircularloader(true);
        globalPostService(apiUrl, payload)
            .then((response) => {
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    toggleModalFn();
                    getAirCraftModels();
                    setPageSelections({})
                    trackActivity('Console Management', {
                        event_desc: type === 'link' ? `Aircraft Model Linked Successfully` : 'Aircraft Model unLinked Successfully',
                        page_title: 'Config Data : Aircraft Types View Page',
                        event_type: type === 'link' ? 'Item Linked' : 'Item UnLinked',
                        updated_id: type === 'link' ? ids : idss || null,
                        success_msg: response?.data?.message,
                        data:JSON.stringify(payload)
                    })
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    getAirCraftModels();
                    toggleModalFn();
                    setPageSelections({})
                    trackActivity('Console Management', {
                        event_desc: type === 'link' ? 'Aircraft Model Linking Failed' : 'Aircraft Model Unlinking Failed',
                        page_title: 'Config Data : Aircraft Types View Page',
                        event_type: type === 'link' ? 'Item Linked' : 'Item UnLinked',
                        updated_id: type === 'link' ? ids : idss || null,
                        error_msg: response?.data?.message,
                        data:JSON.stringify(payload)
                    })
                }
                setCircularloader(false);
            })
    }

    const handleSelectAll = (event, currentPage) => {
        if (event?.target.checked) {
            const allIds = aircraftModelsInfo?.list.map(item => item.id);
            setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: allIds }));
        } else {
            setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: [] }));
        }
    };

    const getFilteredSelectionCounts = () => {
        let deleteCount = 0;
        let revertCount = 0;

        if (pageSelections[currentPage]?.length) {
            pageSelections[currentPage].forEach(id => {
                const selectedItem = aircraftModelsInfo.list.find(item => item.id === id);
                if (selectedItem) {
                    if (selectedItem.deleted_at) {
                        revertCount++;
                    } else {
                        deleteCount++;
                    }
                }
            });
        }
        return { deleteCount, revertCount };
    };

    const { deleteCount, revertCount } = getFilteredSelectionCounts();

    const createSortHandler = (key) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort_by: 'asc' }
        }
        setSortInfo(sortQuery)
        getAirCraftModels({ ...filter, ...sortQuery, page: 1, per_page: aircraftModelsInfo?.pagination?.per_page || 20 }, 'pageLoader');
    }

    const isSelectAllChecked = aircraftModelsInfo?.list?.length > 0 && pageSelections[currentPage]?.length === aircraftModelsInfo?.list?.length;

    const getConfirmColor = () => {
        if (revertAircraftModels?.modal || bulkRevert?.modal) return "primary";
        if (deleteAircraftModels?.modal || bulkDelete?.modal) return "secondary";
        if (unLinkAircarftModels?.modal || bulkUnlink?.modal) return "secondary";
        return "";
    };

    const getConfirmText = () => {
        if (revertAircraftModels?.modal || bulkRevert?.modal) return "Revert";
        if (deleteAircraftModels?.modal || bulkDelete?.modal) return "DELETE";
        if (unLinkAircarftModels?.modal || bulkUnlink?.modal) return "UnLink"
        return "";
    };

    const getModal = () => {
        if (revertAircraftModels?.modal) return revertAircraftModels.modal;
        if (deleteAircraftModels?.modal) return deleteAircraftModels.modal;
        if (bulkDelete?.modal) return bulkDelete.modal;
        if (bulkRevert?.modal) return bulkRevert.modal;
        if (unLinkAircarftModels?.modal) return unLinkAircarftModels.modal;
        if (bulkUnlink?.modal) return bulkUnlink.modal;
        return null;
    };

    const getTitle = () => {
        if (revertAircraftModels?.modal) return "Revert Aircraft Models";
        if (deleteAircraftModels?.modal) return "Delete Aircraft Models";
        if (bulkDelete?.modal) return `Delete Aircraft Models (${deleteCount})`;
        if (bulkRevert?.modal) return `Revert Aircraft Models (${revertCount})`;
        if (unLinkAircarftModels?.modal) return "UnLink Aircraft Models"
        if (bulkUnlink?.modal) return `Unlink Aircraft Models (${deleteCount})`
        return "";
    };

    const getContent = () => {
        if (revertAircraftModels?.modal || bulkRevert?.modal)
            return "Are you sure, you want to Revert?";
        if (deleteAircraftModels?.modal || bulkDelete?.modal)
            return "Are you sure, you want to Delete?";
        if (unLinkAircarftModels?.modal || bulkUnlink?.modal)
            return "Are you sure, you want to UnLink"
        return "";
    };

    const toggleModalFn = () => {
        if (revertAircraftModels?.modal) {
            setRevertAircraftModels({ modal: false, data: null });
        } else if (deleteAircraftModels?.modal) {
            setDeleteAircraftModels({ modal: false, data: null });
        } else if (bulkDelete?.modal) {
            setBulkDelete({ modal: false, data: null });
        } else if (bulkRevert?.modal) {
            setBulkRevert({ modal: false, data: null });
        } else if (bulkUnlink?.modal) {
            setBulkUnLink({ modal: false, data: null });
        } else if (unLinkAircarftModels?.modal) {
            setUnLinkAircarftModels({ modal: false, data: null });
        } else {
            setLinkingAircraftModel({ modal: false, data: null });
        }
    };

    const getDeleteRecordFn = () => {
        if (revertAircraftModels?.modal || bulkRevert?.modal) return onRevert;
        if (deleteAircraftModels?.modal || bulkDelete?.modal) return onDelete;
        if (unLinkAircarftModels?.modal || bulkUnlink?.modal) return linkUnlink || null;
        return null;
    };

    const filterOption = (
        {
            'name': {
                'inputType': 'text',
                'title': 'Name',
            },
            'aircraft_type':{
                'inputType':'dropdown',
                'title':'Aircraft Type',
                'options':aircraftTypeInfo,
                'labelKey':'name',
                'valueKey':'id',
            }
        })
    const getAircraftType = () => {
        globalGetService(`config-data/aircraft-type/?lite=true`)
            .then(response => {
                if (checkApiStatus(response)) {
                    let aircraftTypeInfo = [];
                    const data = response?.data?.data;
                    data && data.map((item) => {
                        aircraftTypeInfo.push({ id: item?.id, name: item?.name })
                    });
                    setAircraftTypeInfo(aircraftTypeInfo);
                }
            })
    }
    
    return (
        <section className="asset-tech-specs" style={{ margin: isModel ? '0px' : '25px 0 0 75px', paddingTop: isModel ? '8px' : '' }}>
            {checkPermission('config_data', 'aircraft_models', 'R') ?  <Paper elevation={isModel ? 0 : 1} className="tech-specs-card" style={{ height: isModel ? `${window.innerHeight - 490}px` : `${window.innerHeight - 89}px` }}>
                {!isModel ? <ConfigData /> : null}
                <div className="tech-specs-content" style={{ padding: isModel ? "0px 0px 0px 0px" : '0px', margin: isModel ? "0px" : '' }}>
                    {skeletonLoader ? <STableLoader count={6} size={9} /> :
                        <div style={{ padding: isModel ? '0px' : '10px' }}>
                            <Paper elevation={0} className="console-paper" style={{ padding: '4px 8px', marginBottom: "2px" }}>
                                <Grid container spacing={1} alignItems="center">
                                    <Grid item md={6}>
                                            {!isModel ? <FilterComponent
                                                filter={filter}
                                                filterMenu={filterOption}
                                                getResponseBack={(applyFilter) => { getAirCraftModels({ ...applyFilter, page: 1, per_page: aircraftModelsInfo?.pagination?.per_page || 10 }, 'pageLoader') }}
                                            /> : null }
                                    </Grid>
                                    <Grid item md={6}>
                                        {!isModel ? <ul className='list-inline flex-centered' style={{ float: 'right' }}>
                                            {revertCount > 0 && (
                                                <li className='list-inline-item'>
                                                    <Button onClick={() => { setBulkRevert({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Aircraft Models', item_type: 'Bulk Revert', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Revert Modal from Aircraft Models` }) }} color="primary" size='small' variant="outlined">
                                                        Revert ({revertCount})
                                                    </Button>
                                                </li>
                                            )}
                                            {deleteCount > 0 && (
                                                <li className='list-inline-item'>
                                                    <Button onClick={() => { setBulkDelete({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Aircraft Models', item_type: 'Bulk Delete', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Delete Modal from Aircraft Models` }) }} color="secondary" size='small' variant="contained">
                                                        Delete ({deleteCount})
                                                    </Button>
                                                </li>
                                            )}
                                            {checkPermission('config_data', 'aircraft_models', 'C')   && <li className='list-inline-item'>
                                                <Button onClick={() => setAddEditAircraftModels({ modal: true, data: AircraftModelsObj, type: 'add' })} color="primary" size='small' variant="contained"><AddIcon style={{ fontSize: '1.15rem' }} />ADD</Button>
                                            </li>}

                                            <li className='list-inline-item' style={{ cursor: 'pointer' }}>
                                                <RevisionHistory isExp={false} buttonType={true} url={`audit/config-data/cdaircrafttypemodel/`} queryParams={{ action: '0,1,2' }} />
                                            </li>
                                          
                                        </ul> : !deleted ?
                                            <ul style={{ textAlign: "right" }}>
                                                    {deleteCount > 0 && checkPermission('config_data', 'aircraft_models', 'D') && (
                                                        <li className='list-inline-item'>
                                                            <Button onClick={() => { setBulkUnLink({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Aircraft Model', item_type: 'Bulk Unlink', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Unlink Aircraft Model to Aircraft Type` }) }} color="secondary" size='small' variant="contained">
                                                                Unlink ({deleteCount})
                                                            </Button>
                                                        </li>)}
                                                    {checkPermission('config_data', 'aircraft_models', 'U') && <li className='list-inline-item'>
                                                        <Button onClick={() => setLinkingAircraftModel({ modal: true, data: aircraftModelsInfo })} color="primary" size='small' variant="contained">Link Aircraft Model</Button>
                                                    </li>}
                                                    <li className='list-inline-item' style={{ cursor: 'pointer', verticalAlign: 'middle' }}>
                                                        <RevisionHistory isExp={false} buttonType={true} url={`audit/config-data/cdaircrafttypemodel/`} queryParams={{ action: '0,1,2' }} objectReprLabel />
                                                    </li>

                                            </ul> : null}
                                    </Grid>
                                </Grid>
                            </Paper>
                            <Paper square >
                              <div style={{ height: isModel ? `${(window.innerHeight - (aircraftModelsInfo?.list?.length ? 535 : 480)) - navTitleOffset}px` :`${(window.innerHeight - (aircraftModelsInfo?.list?.length ? 200 : 150)) - navTitleOffset}px`, overflow: 'auto' }}>
                                <Table className='mui-table-format' stickyHeader>
                                    <AircraftModelsHeader isSelectAllChecked={isSelectAllChecked} deleted={deleted} handleSelectAll={(e) => handleSelectAll(e, currentPage)} createSortHandler={createSortHandler} sortInfo={sortInfo} isModel={isModel} />
                                    <TableBody>
                                        {aircraftModelsInfo?.list?.length > 0 && aircraftModelsInfo?.list?.map((item, index) =>
                                            <AircraftModelsList
                                                isModel={isModel}
                                                deleted={deleted}
                                                item={item}
                                                index={index}
                                                unLink={setUnLinkAircarftModels}
                                                onDelete={setDeleteAircraftModels}
                                                onRevert={setRevertAircraftModels}
                                                onEditFn={() => setAddEditAircraftModels({ modal: true, data: item, type: 'edit' })}
                                                onViewFn={() => setAddEditAircraftModels({ modal: true, data: item, type: 'view' })}
                                                toggleBulkOps={(item, checked) => toggleBulkOps(item, checked, currentPage)}
                                                bulkIds={pageSelections[currentPage] || []}
                                            />
                                        )}
                                    </TableBody>
                                 </Table>
                                   {!aircraftModelsInfo?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                                </div>
                            </Paper>
                            <Paper square>
                                <Pagination
                                    pagination={aircraftModelsInfo?.pagination}
                                    onChangePage={(event, newPage) => { getAirCraftModels({ ...filter, page: newPage + 1, per_page: aircraftModelsInfo.pagination?.per_page, sort_by: sortInfo?.sort_by, sort: sortInfo?.sort }, 'pageLoader'); setCurrentPage(newPage + 1) }}
                                    onChangeRowsPerPage={(event) => getAirCraftModels({ ...filter, page: 1, per_page: event.target.value, sort_by: sortInfo?.sort_by, sort: sortInfo?.sort }, 'pageLoader')}
                                />
                            </Paper>
                        </div>}
                </div>
                {addEditAircraftModels?.modal ?
                    <AddEditAircraftModels
                    aircraftTypeInfo={aircraftTypeInfo}
                        addEditAircraftModels={addEditAircraftModels}
                        aircraftModelsInfo={aircraftModelsInfo}
                        toggleModalFn={() => setAddEditAircraftModels({ modal: false, aircraftModels: [] })}
                        getResponseBack={() => getAirCraftModels({ ...filter, page: aircraftModelsInfo?.pagination?.page, per_page: aircraftModelsInfo?.pagination?.per_page }, 'pageLoader')}
                        modeType={addEditAircraftModels?.type}
                    /> : null
                }
                <DeletePopUp
                    confirmColor={getConfirmColor()}
                    confirmText={getConfirmText()}
                    modal={getModal()}
                    title={getTitle()}
                    content={getContent()}
                    toggleModalFn={toggleModalFn}
                    deleteRecordFn={getDeleteRecordFn()}
                    circularloader={circularLoader}
                />
            </Paper> 
            : 
            <NoAccess />}
            {isLoading ? <PageLoader /> : null}
            {linkingAircraftModel.modal &&
                <LinkingPopup
                    title="Aircraft Model"
                    circularloader={circularLoader}
                    linkUnlink={(type, ids) => linkUnlink(type, ids)}
                    placeholder='Search By Aircraft Model ...'
                    description='No Aircraft Models is available to link'
                    url={`config-data/aircraft-type/?linked_aircraft_types_name=aircraft_model&id=${params?.id}&action=unlink`}
                    data={aircraftModelsInfo}
                    toggleModalFn={() => setLinkingAircraftModel({ modal: false, data: null })}
                />
            }
        </section >
    )
}

export default withRouter(AircraftModels);